<template>
  <main id="js-page-content" role="main" class="page-content">
    <ol class="breadcrumb page-breadcrumb">
      <li class="breadcrumb-item">
        <a href="javascript:void(0);">SmartAdmin</a>
      </li>
      <li class="breadcrumb-item">Category</li>
      <li class="breadcrumb-item">Sub-category</li>
      <li class="breadcrumb-item active">Page Title</li>
      <li class="position-absolute pos-top pos-right d-none d-sm-block">
        <span class="js-get-date"></span>
      </li>
    </ol>
    <div class="subheader">
      <h1 class="subheader-title">
        <i class="subheader-icon fal fa-globe"></i> toaster
        <span class="fw-300">サンプル</span>
        <sup class="badge badge-primary fw-500">STICKER</sup>
        <small> Insert page description or punch line </small>
      </h1>
      <!-- 
		Right content on content header
		A nice area to add graphs or buttons -->
      <div class="subheader-block">Right Subheader Block</div>
    </div>

    <div class="alert alert-primary">
      <div class="d-flex flex-start w-100">
        <div class="mr-2 hidden-md-down">
          <span class="icon-stack icon-stack-lg">
            <i
              class="base base-6 icon-stack-3x opacity-100 color-primary-500"
            ></i>
            <i
              class="base base-10 icon-stack-2x opacity-100 color-primary-300 fa-flip-vertical"
            ></i>
            <i
              class="ni ni-blog-read icon-stack-1x opacity-100 color-white"
            ></i>
          </span>
        </div>
        <div class="d-flex flex-fill">
          <div class="flex-fill">
            <span class="h5">注意事項!</span>
            <p>特に注意事項はないです</p>
            <p class="m-0">
              Follow a slogal with a useful link or call to action
              <a href="#" target="_blank">Call to action >></a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div id="panel-x" class="panel">
          <div class="panel-hdr">
            <h2>button</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-close"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Close"
              ></button>
            </div>
          </div>
          <div class="panel-container show">
            <div class="panel-content">
              <div class="frame-wrap">
                <div class="demo">
                  <div class="panel-tag">
                    4種類の通知を用意しているので、必要に応じて使い分ける。
                  </div>
                  <button
                    @click="showNotification()"
                    type="button"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    notifications表示
                  </button>
                  <button
                    @click="showNotification2()"
                    type="button"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    全通知表示
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { Cl_notifications, toasterType } from "@/functions/Cl_notifications";

@Options({})
export default class Toaster extends Vue {
  async showNotification(): Promise<void> {
    Cl_notifications.showToastr(
      toasterType.success,
      "おめでとう、通知は表示された"
    );
  }
  async showNotification2(): Promise<void> {
    Cl_notifications.showToastr(
      toasterType.success,
      "おめでとう、通知は表示された"
    );
    Cl_notifications.showToastr(toasterType.error, "error");
    Cl_notifications.showToastr(toasterType.warning, "warning");
    Cl_notifications.showToastr(toasterType.info, "info");
  }
}
</script>
